import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeader from "../components/ui/PageHeader";
import TaskList from "../components/tasks/TaskList";
import TaskForm from "../components/tasks/TaskForm";
import TaskDetail from "../components/tasks/TaskDetail";
import { Box, Button, Dialog, DialogContent, useTheme } from "@mui/material";
import { Add } from "@mui/icons-material";

const TasksPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const [showForm, setShowForm] = useState(false);
  const [editingTask, setEditingTask] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (searchParams.get("new") === "true") {
      setShowForm(true);
    }
  }, []);

  const handleEdit = (task) => {
    setEditingTask(task);
    setShowForm(true);
  };

  const handleSelectTask = (task) => {
    setSelectedTask(task);
  };

  const handleSave = () => {
    setShowForm(false);
    setEditingTask(null);
    setRefreshKey((k) => k + 1);
  };

  const handleCloseDetail = () => {
    setSelectedTask(null);
  };

  const handleView = (task) => {
    setSelectedTask(task);
  };

  return (
    <Box>
      <PageHeader
        title="Tareas"
        action={
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => {
              setEditingTask(null);
              setShowForm(true);
            }}
            sx={{
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: 'none',
              '&:hover': {
                boxShadow: `0 4px 12px ${theme.palette.primary.main}40`,
                filter: 'brightness(1.05)',
              },
            }}
          >
            Nueva Tarea
          </Button>
        }
      />

      <TaskList
        key={refreshKey}
        onEdit={handleEdit}
        onView={handleView}
        onRefresh={() => setRefreshKey(k => k + 1)}
      />

      {/* Diálogo del formulario */}
      <Dialog
        key={editingTask?.id || "new"}
        open={showForm}
        onClose={() => {
          setShowForm(false);
          setEditingTask(null);
        }}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            maxHeight: "90vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <TaskForm
            task={editingTask}
            onSave={handleSave}
            onCancel={() => {
              setShowForm(false);
              setEditingTask(null);
            }}
          />
        </DialogContent>
      </Dialog>

      {/* Diálogo de detalle */}
      <Dialog
        open={!!selectedTask}
        onClose={handleCloseDetail}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
          },
        }}
      >
        <DialogContent sx={{ p: 0 }}>
          <TaskDetail
            task={selectedTask}
            onEdit={handleEdit}
            onClose={handleCloseDetail}
            onRefresh={() => setRefreshKey(k => k + 1)}
          />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default TasksPage;